import * as productApis from './../apis/product';
import * as productContant from './../contants/product';

 
//
export const fetchListProductContant = () =>{
	return {
		type: productContant.FETCH_PRODUCT,
	}
}
export const fetchListProductContantSuccess = data =>{
	return {
		type: productContant.FETCH_PRODUCT_SUCESS,
		payload: {
			data
		}
	}
}
export const fetchListProductContantFailed = err =>{
	return {
		type: productContant.FETCH_PRODUCT_FAILED,
		payload: {
			err
		}
	}
} 

export const fetchListProduct = () =>{
	return dispatch =>{
		dispatch(fetchListProductContant());
		productApis
			.getList().then(res =>{
				const {data} = res
				dispatch(fetchListProductContantSuccess(data));
		}).catch(err =>{
			dispatch(fetchListProductContantFailed(err));
		})
	}
}

